import { html } from "lit";

export default  (o) => html`<p class="form-help">${o.text}</p>`;
